export default __webpack_public_path__ + "static/media/icon_trash_sml.31c449c5.svg";